import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import UnpaidOrdersLayer from "../../components/orders/UnpaidOrdersLayer";

const UnpaidOrdersPage = () => {
    return (
        <MasterLayout>
            <UnpaidOrdersLayer />
        </MasterLayout>
    );
};

export default UnpaidOrdersPage;
